import { io } from 'socket.io-client';

const socketUrl = process.env.NODE_ENV === 'production'
  ? 'https://imagen.cetemin.net.pe:4001'
  : `${window.location.protocol}//${window.location.hostname}:4001`;

export const socket = io(socketUrl);